import { getOrCreateCart } from '../storefront-cart';
import { useEffect, useState } from 'preact/hooks';

import { EmbarkCart } from 'shopify-buy';
import { DrawerFooter } from './DrawerFooter';
import { EmptyCart } from './EmptyCart';
import { LineItem } from './LineItem';
import { LoadingCart } from './LoadingCart';
import React from 'preact/compat';
import { Recommendations } from './Recommendations';
import { ValueProps } from './ValueProps';
import { getValProps } from './Drawer';
import { notifyHandledException } from '../../utils/errorLogger';

export const CartPage: React.FC = () => {
  const [cart, setCart] = useState<EmbarkCart | null>(null);

  useEffect(() => {
    getOrCreateCart()
      .then((cart) => {
        setCart(cart);
        document.dispatchEvent(
          new CustomEvent('cart-drawer:opened', { detail: { cart } })
        );
      })
      .catch(notifyHandledException);
  }, []);

  if (!cart) {
    return (
      <div class={'cart-page'}>
        <LoadingCart />
      </div>
    );
  }

  if (!cart.lines.edges.length) {
    return (
      <div class={'cart-page'}>
        <h1 className={'text-center'}>Cart (0)</h1>
        <EmptyCart showCTA={true} />
      </div>
    );
  }

  return (
    <div className={'cart-page'}>
      <h1>Cart</h1>
      <div className={'cart-page__grid'}>
        <div className="line-items cart-page__line-items">
          {cart.lines.edges.map((line) => {
            const item = line.node;
            return (
              <div key={item.id} className="line-item">
                <LineItem
                  item={item}
                  onChange={() => {
                    getOrCreateCart()
                      .then((updatedCart) => {
                        setCart(updatedCart);
                      })
                      .catch(notifyHandledException);
                  }}
                />
              </div>
            );
          })}
        </div>
        <div id="cart-page__offer" className="cart-page__offer"></div>
        <div className={'cart-page__recommendations'}>
          {cart && (
            <Recommendations
              cart={cart}
              onChange={() => {
                getOrCreateCart()
                  .then((updatedCart) => setCart(updatedCart))
                  .catch(notifyHandledException);
              }}
            />
          )}
        </div>
        <div className={'cart-page__footer'}>
          {cart && <DrawerFooter cart={cart} />}
          <div className="cart-page__value-props">
            {cart && <ValueProps props={getValProps(cart)} />}
          </div>
        </div>
      </div>
    </div>
  );
};
